import React, { useEffect } from 'react'
import Checkbox from '@mui/material/Checkbox';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import FormControlLabel from '@mui/material/FormControlLabel';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import TextsmsOutlinedIcon from '@mui/icons-material/TextsmsOutlined';

import SectionHeader from "../../../components/SectionHeader/sectionHeader";

import { authActions } from '../../../redux/auth/auth.actions';
import { useAppDispatch } from '../../../redux/store/store';

export default function ClientNotifications(props : any) {

    // Props
    const {user, emailNotifications, setSmsNotifications, smsNotifications, setEmailNotifications, accountPreferencesData } = props


    // hooks
    const dispatch = useAppDispatch();

    useEffect(() => {
        fetchPreferences();
    }, []);

     const fetchPreferences = () => {
            dispatch(authActions?.getUserPreferencesAction(user?.id))
    }
    
    const handleUpdatePreference = (name: string) => {
    
            if(name === "emailNotifications"){
                setEmailNotifications(!emailNotifications)
            }
    
            if(name === "smsNotifications"){
                setSmsNotifications(!smsNotifications);
            }
    
            const data = {
                ...accountPreferencesData,
                [name]: !accountPreferencesData[name]
            }
    
            dispatch(authActions?.updateUserPreferencesAction({
                id: user?.id,
                data
            }))
                .then((res: any) => {
                    if(res?.payload?.data?.status === 200){
                        fetchPreferences();
                    }else{
                        // show error
                    }
                })
                .catch((err: any) => {
                    console.log(err)
                    // show error
                })
    }
  return (
    <>
        <SectionHeader className="boxTitle section-heading">
            <h4 >Notifications Preferences</h4>
        </SectionHeader>

        <p className='ac-pref-warn-text'><WarningAmberIcon /> Note: You will always receive critical notifications about your account and project, regardless of your notification settings.<br /> This includes security alerts, billing updates, and important project changes.</p>

        <div className='ac-pref-notification-sec'>
            <div className='notifications-item'>
                <FormControlLabel 
                    control={
                        <Checkbox 
                            checked={emailNotifications}
                            onChange={(e: any) => {
                                handleUpdatePreference("emailNotifications")
                            }}
                        />
                    } 
                    label="" 
                />
                <MailOutlineIcon />
                <h5> Email Notifications</h5>
            </div>
            <div className='notifications-item'>
                <FormControlLabel 
                    control={
                        <Checkbox 
                            checked={smsNotifications}
                            onChange={(e: any) => {
                                handleUpdatePreference("smsNotifications")
                            }}
                        />
                    } 
                    label="" 
                />
                <TextsmsOutlinedIcon />
                <h5> SMS Notifications</h5>
            </div>

            {/* <Accordion>
                <AccordionSummary expandIcon={<ExpandMoreIcon />} className="ac-pref-accord-title">
                    <h4>
                        <MailOutlineIcon />
                        <span>
                            <strong>Email Notifications</strong>
                            The following notifications will be sent to you via email
                        </span>
                    </h4>
                </AccordionSummary>
                <AccordionDetails className='ac-preef-accord-detail'>
                    <FormGroup>
                        <FormControlLabel control={<Checkbox defaultChecked />} label="Notification Type" />
                        <FormControlLabel control={<Checkbox defaultChecked />} label="Notification Type" />
                        <FormControlLabel control={<Checkbox defaultChecked />} label="Notification Type" />
                        <FormControlLabel control={<Checkbox defaultChecked />} label="Notification Type" />
                    </FormGroup>
                </AccordionDetails>
            </Accordion>
            <Accordion>
                <AccordionSummary expandIcon={<ExpandMoreIcon />} className="ac-pref-accord-title">
                    <h4>
                        <TextsmsOutlinedIcon />
                        <span>
                            <strong>SMS Notifications</strong>
                            The following notifications will be sent to you via email
                        </span>
                    </h4>
                </AccordionSummary>
                <AccordionDetails className='ac-preef-accord-detail'>
                    <FormGroup>
                        <FormControlLabel control={<Checkbox defaultChecked />} label="Notification Type" />
                        <FormControlLabel control={<Checkbox defaultChecked />} label="Notification Type" />
                        <FormControlLabel control={<Checkbox defaultChecked />} label="Notification Type" />
                        <FormControlLabel control={<Checkbox defaultChecked />} label="Notification Type" />
                    </FormGroup>
                </AccordionDetails>
            </Accordion> */}
        </div>

        {/* <div className='ac-preef-check-subscribe'>
            <FormGroup>
                <FormControlLabel control={<Checkbox defaultChecked />} label="Subscribe to the Chapter Newsletter" />
            </FormGroup>
        </div> */}
    </>
  )
}
